// extracted by mini-css-extract-plugin
export default {"mockPaypalButton":"_2zwJO","loader":"_2G_v_"};